import { HttpService } from "@/core";

import { ApprovalFLowLogPageReq, ApprovalFLowLogListResp } from "./approval-flow-log.interface";

export class ApprovalFlowLogService {
  static usePageApi() {
    const api = (params: ApprovalFLowLogPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/examine_log/page",
        params,
      });
    return HttpService.usePagination<ApprovalFLowLogListResp>(api);
  }
}
